import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/coupons/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
